export function transpose(m) {
    var _a;
    return ((_a = m[0]) === null || _a === void 0 ? void 0 : _a.map(function (x, i) { return m.map(function (x) { return x[i]; }); })) || [];
}
//# sourceMappingURL=transpose.js.map